var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"account-edit-modal"},[_c('EditAccountDetails',{attrs:{"accountId":_vm.account.id},on:{"updateAccount":_vm.updateAccountHandler,"closeModal":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }